export default __webpack_public_path__ + "static/media/veal.fc850bec.jpg";